const ContingencySection = ({
  children,
  className,
  flex,
}: {
  children: React.ReactNode;
  className?: string;
  flex?: boolean;
}) => (
  <div
    className={`flex flex-col gap-[var(--spacing-md)] ${className ?? ""}`}
    style={flex ? { flex: 1 } : undefined}
  >
    {children}
  </div>
);

export default ContingencySection;
